import { useRecoilState } from 'recoil';
import { Button } from 'components/core';
import { builderAnswersState } from 'states';
import { ExtraAnswers } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { TextBox } from './TextBox';
import { OUTLINE_SMALL } from './buttonProps';



// Advanced: a backend handler and dashboard filters, the parts of a stored KPI that hand-written JSON can set on any KPI.
export const ExtraOptionsStep = () => {
  const [a, setA] = useRecoilState(builderAnswersState);
  const extras = a.extras;
  const save = (next: Partial<ExtraAnswers>) => setA({ ...a, extras: { ...extras, ...next } });
  const setFilter = (i: number, next: Partial<ExtraAnswers['filters'][number]>) => save({ filters: extras.filters.map((f, j) => (j === i ? { ...f, ...next } : f)) });

  return (
    <>
      <BuilderSection title="Backend handler (advanced)" hint="Leave blank for most KPIs. Type a handler key only if the backend has a handler written for this KPI. The KPI works only if that handler exists.">
        <TextBox value={extras.handlerKey} placeholder="Handler key, e.g. dropoutrate" onChange={(handlerKey) => save({ handlerKey })} />
      </BuilderSection>
      <BuilderSection title="Dashboard filters (advanced)" hint="Add a filter name from the dashboard and the field it should narrow, such as “Facility Name” and facilityName. Leave “Query” blank to apply it to every query, or type 1 or 2 for just that query.">
        {extras.filters.map((f, i) => (
          <div key={i} className="row g-2 mb-2">
            <div className="col-md-4"><TextBox value={f.key} placeholder="Filter name, e.g. Course" onChange={(key) => setFilter(i, { key })} /></div>
            <div className="col-md-4"><TextBox value={f.field} placeholder="Field, e.g. courseId" onChange={(field) => setFilter(i, { field })} /></div>
            <div className="col-md-2"><TextBox value={f.on} placeholder="Query" onChange={(on) => setFilter(i, { on })} /></div>
            <div className="col-md-2">
              <Button {...OUTLINE_SMALL} onClick={() => save({ filters: extras.filters.filter((_, j) => j !== i) })}>Remove</Button>
            </div>
          </div>
        ))}
        <Button {...OUTLINE_SMALL} onClick={() => save({ filters: [...extras.filters, { key: '', field: '', on: '' }] })}>Add a dashboard filter</Button>
      </BuilderSection>
    </>
  );
};
